import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SendRecoveryPasswordMailRequest } from '../../models/SendRecoveryPasswordMailRequest.model';
import { LoginPageComponent } from '../../page/login/loginPage.component';
import { EmailSendDialogComponent } from '../email-send-dialog/email-send-dialog.component';
import { AuthService } from '../../services/Auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-send-recovery-password-dialog',
  templateUrl: './send-recovery-password-dialog.component.html',
  styleUrls: ['./send-recovery-password-dialog.component.css']
})
export class SendRecoveryPasswordDialogComponent implements OnInit {

  formChangePassword: FormGroup;
  recoveryPasswordRequest = {} as SendRecoveryPasswordMailRequest;

  suscription_sendRecoveryPassword: Subscription;

  constructor(public dialogRef: MatDialogRef<LoginPageComponent>, 
    @Inject(MAT_DIALOG_DATA) public obj: any,
    private formBuilder: FormBuilder, 
    private authPasswordService: AuthService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.formChangePassword = this.formBuilder.group({
      email: ["", Validators.required, Validators.email]
    });
  }

  ngOnDestroy(): void {
    if (this.suscription_sendRecoveryPassword)
      this.suscription_sendRecoveryPassword.unsubscribe();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  EmailSendDialog() {
    const dialogRef = this.dialog.open(EmailSendDialogComponent, {
      width: '450px',
      data: { name: 'Angular' },
      panelClass: 'dialog-container-custom'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  sendRecoveryMail() {
    var email = this.formChangePassword.get('email').value;
    this.recoveryPasswordRequest.email = email;
    this.suscription_sendRecoveryPassword = this.authPasswordService.sendRecoveryPasswordEmail(this.recoveryPasswordRequest).subscribe(response => {
      if (response.isSuccess) {
        this.EmailSendDialog();
        this.closeDialog();
      }
    });
  }

}
